import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
// utilities
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// type
import { TMainPageLayoutV3 } from "../type";


const MNPG045 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG045.rendered: ", props);

    const location = useLocation();
    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);

    if ( !props.params?.["contentDetails"] ) return null;

    const redirectURL = metaDataLanguageVersion("redirectURL",props.params["contentDetails"]?.languageVersions);
    if ( redirectURL ) {
        return <Navigate to={redirectURL} replace={true} />;
    }

    const redirectPath = metaDataLanguageVersion("redirectPath",props.params["contentDetails"]?.languageVersions);
    if ( redirectPath ) {
        const _redirectPath = `/${webApplicationLanguageISOCode}/${redirectPath}`.replaceAll("//", "/");
        if ( location.pathname !==_redirectPath ) return <Navigate to={_redirectPath} replace={true} />;;
    }

    return null;
}

const Component = React.memo(MNPG045, ( prevProps:TMainPageLayoutV3, nextProps:TMainPageLayoutV3 ) => {
    return true;
});

export default Component;
